import recordRequest from '@/utils/recordRequest'

export type RecordStatus = 'pending' | 'normal' | 'overdue' | 'changed'

export interface PersonalRecord {
  id?: number
  product: string
  title: string
  version?: string
  expectedLaunchDate?: string
  launchDate?: string
  status?: RecordStatus
  changeRemark?: string
  createTime?: string
  updateTime?: string
}

export interface PageResult<T> {
  total: number
  records: T[]
}

export interface RecordStats {
  total: number
  pending: number
  normal: number
  overdue: number
  changed: number
}

export const STATUS_MAP: Record<RecordStatus, string> = {
  pending: '待上线',
  normal: '正常上线',
  overdue: '逾期上线',
  changed: '任务变更'
}

/** 根据日期自动推断状态 */
export function inferStatus(record: Pick<PersonalRecord, 'launchDate' | 'expectedLaunchDate' | 'status'>): RecordStatus {
  if (record.launchDate) {
    if (record.expectedLaunchDate && record.launchDate > record.expectedLaunchDate) return 'overdue'
    return 'normal'
  }
  if (record.status === 'changed') return 'changed'
  return 'pending'
}

/** 分页查询 */
export const pageRecords = (params: {
  page?: number
  pageSize?: number
  keyword?: string
  product?: string
  status?: RecordStatus
  startDate?: string
  endDate?: string
}) =>
  recordRequest.get<any, PageResult<PersonalRecord>>('/user/record/page', { params })

/** 统计数据 */
export const getRecordStats = () =>
  recordRequest.get<any, RecordStats>('/user/record/stats')

/** 产品列表 */
export const listRecordProducts = () =>
  recordRequest.get<any, string[]>('/user/record/products')

/** 新建产品 */
export const createProduct = (name: string) =>
  recordRequest.post<any, void>('/user/record/products', { name })

/** 重命名产品（同步更新该产品下所有发版记录） */
export const renameProduct = (oldName: string, newName: string) =>
  recordRequest.put<any, void>('/user/record/products/rename', { oldName, newName })

/** 删除产品（同时删除该产品下全部发版记录） */
export const deleteProduct = (name: string) =>
  recordRequest.delete<any, void>('/user/record/products', { params: { name } })

/** 新增 */
export const createRecord = (data: PersonalRecord) =>
  recordRequest.post<any, PersonalRecord>('/user/record', data)

/** 更新 */
export const updateRecord = (id: number, data: PersonalRecord) =>
  recordRequest.put<any, PersonalRecord>(`/user/record/${id}`, data)

/** 标记今日上线 */
export const markRecordLaunched = (id: number) =>
  recordRequest.put<any, PersonalRecord>(`/user/record/${id}/launch`)

/** 标记任务变更 */
export const markRecordChanged = (id: number, changeRemark: string) =>
  recordRequest.put<any, PersonalRecord>(`/user/record/${id}/change`, { changeRemark })

/** 删除 */
export const deleteRecord = (id: number) =>
  recordRequest.delete<any, void>(`/user/record/${id}`)
